<template>
	<div class="no-wrap has-background-white batch-component" style="width:100%;">
        <div class="columns">
            <div class="column is-12">
				<div class="header card-header">
					<button class="button" @click="params.archived = !params.archived, fetch()">
						{{ params.archived ? 'Hide' : 'Show' }} Archived
					</button>
				</div>
				<base-table
					:service="$options.batchService"
					fetch-func="all"
					:fetch-params="params"
					:columns="columns"
					default-sort-direction="desc"
					:narrowed="false"
					ref="baseTable"
					:sticky="true"
					>
					<template #rowAction="{ row }">
						<button class="button is-warning is-small action-button" @click="unbatch(row.id, $event)" v-if="row.invoices.length">
							UNBATCH
						</button>
						<router-link :to="{ name: 'invoices', query: { name: row.text }}">
							<button class="button is-info is-small action-button">
								VIEW BATCH
							</button>
						</router-link>
					</template>
				</base-table>
            </div>
        </div>
    </div>
</template>
<script>
import BaseTable from "@/components/partials/BaseTable";
import { BatchService } from "@/services/batch.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
export default {
	batchService: BatchService,
  	components: {
    	BaseTable,
  	},
    data: () => ({
	    params: {
	    	includes: 'invoices',
	    	archived: false
	    },
    }),
    computed: {
	    columns() {
	        let columns = [];
	        columns.push({field: "id", label: "Id"});
	        columns.push({field: "text", label: "Text"});
	        columns.push({field: "date", label: "Date"});
			columns.push({label: "Action", meta: {
	            rowSlot: "rowAction",
	            class: 'action-td'
	        }});
	        return columns;
	    },
	},
	methods: {
		fetch() {
			return this.$refs.baseTable.fetchData();
		},
		unbatch(id, event) {
			BatchService.unbatch(id).then(response => {
				event.target.classList.toggle('hide')
				this.$buefy.toast.open({
	                message: 'Success',
	                type: "is-success",
					position: "is-top-right"
	            });
			});
		}
	},
	mounted() {
		this.fetch();
	}
};
</script>
<style lang="scss">
.batch-component {
	.action-td{
		width: 200px;
	}
	.action-button {
		width:65px;
	}
	.has-sticky-header{
		height: 80vh !important;
	}
	.card-header {
		padding: 10px 10px 15px;
		display: block;
	}
	.hide {
		display: none;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/Batches/index.vue